/**
 * @file
 * Attaches behaviors for revolution slider video.
 */

!(($, Drupal) => {

  'use strict';
  Drupal.behaviors.sliderRevolutionVideo = {
    attach: function (context) {

      /**
       * Checks if an element is in the viewport
       * @param {object} element Element to check
       * @returns {boolean} TRUE or FALSE
       */
      function isInViewport (element) {
        let elementTop = $(element).offset().top;
        let elementBottom = elementTop + $(element).outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      }

      /**
       * Checks if an element is the most visible of all elements
       * configured with the {selector}
       * @param {object} element Element to check
       * @param {string} selector CSS/JS selector
       * @returns {boolean} TRUE or FALSE
       */
      function isMostVisible (element, selector) {
        if (!isInViewport(element)) {
          return false;
        }

        let $mostVisibleElement = $(selector).mostVisible();
        return $mostVisibleElement.is($(element));
      }

      // eslint-disable-next-line max-len

      const $paragraphTypeSliderRevolution = $(once('paragraphTypeSliderRevolution', '.paragraph--type--slider-revolution', context));
      $paragraphTypeSliderRevolution.each(function () {
          let $root = $(this);
          let $videoContainer = $root.find('video').get(0);

          /**
           * Play/pause video
           * @returns {void}
           */
          function handleVideo () {
            if (isMostVisible($root, '.paragraph--type--slider-revolution')) {
              if ($videoContainer.paused) {
                $videoContainer.play();
              }
            }
            else {
              if (!$videoContainer.paused) {
                $videoContainer.pause();
              }
            }
          }

          if (typeof $videoContainer !== 'undefined') {
            $(window).on('resize scroll', handleVideo);
            handleVideo();
          }
        });

    },
  };
// eslint-disable-next-line no-undef
})(jQuery, Drupal, drupalSettings);
